import React from 'react'
// libs
import styled from 'styled-components'
// components
import MaterialButton from '@mui/material/Button'

export const StyledButton = styled(({ textColor, bg, hoveredBg, shadowLess, ...props }) => (
  <MaterialButton {...props} />
))<{
  bg?: string
  textColor?: string
  hoveredBg?: string
  shadowLess?: boolean
}>`
  && {
    color: white;
    border-radius: 25px;
    max-width: 240px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    ${({ bg }) => bg && `background-color: ${bg}`} !important;
    ${({ border }) => border && `border: ${border}`};
    ${({ cursor }) => cursor && `cursor: ${cursor}`};
    ${({ textColor }) => textColor && `color: ${textColor}`};

    ${({ shadowLess }) => shadowLess && 'box-shadow: none'};

    &:hover {
      ${({ hoveredBg }) => hoveredBg && `background-color: ${hoveredBg}`};
    }
  }
`

export const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  white-space: nowrap;
`

export const LoaderWrapper = styled.div`
  position: absolute;
  top: calc(50% + 2px);
  left: 50%;
  transform: translate(-50%, -50%);

  > div {
    margin: 0 !important;
  }
`
